import React from 'react';
import { Link } from "react-scroll";
const Navbar = () => {
    return ( 
        <div className='navbar_port'>
            <div className='list_nav'>
                <ul>
                    <li>
                        <Link to='/'
                        spy={true} 
                        smooth={true} 
                        offset={-10} 
                        duration={500} >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link to='portfolio'
                        spy={true} 
                        smooth={true} 
                        offset={-30} 
                        duration={800} >
                            Porfolio
                        </Link>
                    </li>
                    <li>
                        <Link to='aboutme'
                        spy={true} 
                        smooth={true} 
                        offset={-50} 
                        duration={1000} >
                            About me
                        </Link>
                    </li>
                    <li>
                        <Link to='contact'
                        spy={true} 
                        smooth={true} 
                        offset={50} 
                        duration={1200} >
                            Contact
                        </Link>
                    </li>

                </ul>
            </div>
        </div>
     );
}
 
export default Navbar;